export const MODE_CALCUL_MANUEL = 'Manuel';
export const MODE_CALCUL_FORFAIT = 'Forfait';
export const MODE_CALCUL_POURCENTAGE = 'Pourcentage';
export const MODE_CALCUL_MULTIPLE = 'Multiple';

export const LISTE_MODE_CALCUL = [
  { code: MODE_CALCUL_MANUEL, libelle: 'creerPanneau.modalCalculHonoraire.mode.manuel' },
  { code: MODE_CALCUL_FORFAIT, libelle: 'creerPanneau.modalCalculHonoraire.mode.forfait' },
  { code: MODE_CALCUL_POURCENTAGE, libelle: 'creerPanneau.modalCalculHonoraire.mode.pourcentage' },
  { code: MODE_CALCUL_MULTIPLE, libelle: 'creerPanneau.modalCalculHonoraire.mode.multiple' },
];